import { OAUTH_REDIRECT_CALLBACK_URL } from '@/features/auth/login/consts/oauth';
import type { Strategy } from '@/features/auth/login/types/login';
import type { useSignIn } from '@clerk/react';

type SignInResource = ReturnType<typeof useSignIn>['signIn'];

export const initiateOAuthRedirect = async (signIn: SignInResource, strategy: Strategy): Promise<void> => {
  const { error } = await signIn.sso({
    strategy,
    redirectCallbackUrl: OAUTH_REDIRECT_CALLBACK_URL,
    redirectUrl: '/'
  });

  if (error) {
    throw error;
  }
};
